import React, { useState, useContext, useEffect } from "react";
import { Field } from "formik";
import {
  FieldInputDollar,
  FieldButtonGroup,
  FieldDropSide,
  SearchableList,
  FieldInput,
  FieldTextarea,
  FieldInputNumber,
  FieldInputPercentage,
  DatePicker,
  MultiSelectDropdown,
  FieldMultiSelectButtonGroup,
  LoaderWrapper,
  AddToolTip,
  GetInitials,
  SliderPanel,
} from "../../../../components";
import {
  yesNoOptions,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  usDateFormat,
  toMultiSelectValueById,
} from "../../../../utils";
import { useRequest, useRouterParams } from "../../../../abstracts";
import {
  listTrustee,
  listCustodian,
  GetInvestmentTradingPartnerList,
  getPlansWithAdvisorRepresentative,
  UpsertAdvisorRepresentativeToInvestment,
  getInvestmentWithAdvisorRepresentative,
} from "../../../../services";
import { createPlanStore } from "../../../../contexts";
import { isEmpty, get, isNull } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/pro-light-svg-icons";
import { Button, Form } from "react-bootstrap";
const AdvisorRepresentativeDetails = (props) => {
  const {
    fields,
    values,
    setFieldValue,
    isEdit,
    isSave,
    planId,
    handleChange,
    setToggle,
    setTabGrey,
  } = props;

  const { state } = useContext(createPlanStore);
  const { flow, planid, investmentId } = useRouterParams();
  const [
    isEditadvisorRepresentative,
    setIsEditadvisorRepresentative,
  ] = useState(false);
  const [
    planadvisorRepresentativeDetails,
    setPlanadvisorRepresentativeDetails,
  ] = useState([]);
  const [
    advisorRepresentativeAccount,
    setadvisorRepresentativeAccount,
  ] = useState({});
  const [investmentPartner, setinvestmentPartner] = useState(0);
  const { response: trusteeList } = useRequest({
    method: listTrustee,
    payload: planId,
    defaultResponse: [],
  });
  const { response: custodianList, loading: load } = useRequest({
    method: listCustodian,
    payload: planId,
    defaultResponse: [],
  });

  // console.log(investmentId,planid,flow, "clearingPartnerAccount");
  useEffect(() => {
    if (isEditadvisorRepresentative) {
      getPlansWithAdvisorRepresentative(planId)
        .then((res) => {
          if (res.isSuccessful) {
            setPlanadvisorRepresentativeDetails(
              get(res, "planAdvisorRepresentatives", [])
            );
          }
        })
        .catch((err) => {});
    }
    getInvestmentWithAdvisorRepresentative(parseInt(investmentId))
      .then((res) => {
        if (res.isSuccessful) {
          setadvisorRepresentativeAccount(
            get(res, "planAdvisorRepresentatives", {})
          );
        }
      })
      .catch((err) => {});
  }, [isEditadvisorRepresentative]);
  const trusteeData = get(trusteeList, "trustees", []);
  const custodianData = get(custodianList, "custodians", []);

  const clearanceTime = get(values, fields.clearanceTime, []);
  const onAddClick = () => {
    setIsEditadvisorRepresentative(!isEditadvisorRepresentative);
  };
  const onSave = () => {
    UpsertAdvisorRepresentativeToInvestment({
      investmentPlanMappingId: parseInt(investmentId),
      advisorRepresentativePlanMappingId: parseInt(investmentPartner),
    })
      .then((res) => {
        setIsEditadvisorRepresentative(!isEditadvisorRepresentative);
      })
      .catch((err) => {});
  };
  console.log(investmentPartner, "investmentPartner");
  return (
    <LoaderWrapper isLoading={false}>
      {!isEmpty(advisorRepresentativeAccount) && (
        <div className="clearing-partner-added-cards">
          <div className="left-component-clearing-partner">
            <div className="clearing-partner-icon-wrapper d-flex justify-content-center">
              {!isEmpty(advisorRepresentativeAccount?.logo) ? (
                <img
                  alt=""
                  src={advisorRepresentativeAccount?.logo}
                  style={{ width: "90px", height: "74px" }}
                  className="img-fluid"
                />
              ) : (
                <GetInitials name={advisorRepresentativeAccount?.firmName} />
              )}
            </div>

            <div className="clearing-partner-description-box">
              <AddToolTip
                name={advisorRepresentativeAccount?.firmName}
                className="ft-14 font-weight-500 pb-3 clearing-partner-name"
              />
              <div className="clearing-partner-associated-plans">
                {advisorRepresentativeAccount?.totalPlans} Associated Plans
              </div>
            </div>
          </div>
          <div className="right-component-investment-clearing-partner">
            <div className="inner-bank-details">
              <div className="ft-14 font-weight-500 pb-3 clearing-partner-name">
                Advisor Representative Details
              </div>
              <AddToolTip
                name={advisorRepresentativeAccount?.representativeName}
                className="ft-14 font-weight-500 pb-3 clearing-partner-name"
              />
              <div className="clearing-partner-associated-plans">
                {advisorRepresentativeAccount?.number}
              </div>
            </div>
            <FontAwesomeIcon
              icon={faEdit}
              className="edit-icon"
              size="2x"
              onClick={onAddClick}
            />
          </div>
        </div>
      )}
      <SliderPanel
        isOpen={isEditadvisorRepresentative}
        size="50"
        onClose={onAddClick}
        showCancel={false}
      >
        <div className="clearing-partner-inside-content">
          <div className="d-flex justify-content-between align-baseline">
            <div>
              <p className="investment-heading">Edit Advisor Representative</p>
            </div>
            <div>
              <Button variant="secondary" onClick={onAddClick}>
                Cancel
              </Button>
              <Button variant="primary" onClick={onSave} className="ml-4">
                Save
              </Button>
            </div>
          </div>
          {!isEmpty(planadvisorRepresentativeDetails) &&
            planadvisorRepresentativeDetails.map((e, i) => {
              return (
                <div className="clearing-partner-added-cards">
                  <div className="left-component-clearing-partner">
                    <Form.Check // prettier-ignore
                      type={"radio"}
                      name="group1"
                      value={e.advisorRepresentativePlanMappingId}
                      id={`default-radio-${i}`}
                      onChange={(e) => setinvestmentPartner(e.target.value)}
                    />

                    <div className="clearing-partner-icon-wrapper d-flex justify-content-center">
                      {!isEmpty(e.logo) ? (
                        <img
                          alt=""
                          src={e.logo}
                          style={{ width: "90px", height: "74px" }}
                          className="img-fluid"
                        />
                      ) : (
                        <GetInitials name={e.firmName} />
                      )}
                    </div>

                    <div className="clearing-partner-description-box">
                      <AddToolTip
                        name={e.firmName}
                        className="ft-14 font-weight-500 pb-3 clearing-partner-name"
                      />
                      <div className="clearing-partner-associated-plans">
                        {e.totalPlans} Associated Plans
                      </div>
                    </div>
                  </div>
                  <div className="right-component-investment-clearing-partner">
                    <div className="inner-bank-details">
                      <div className="ft-14 font-weight-500 pb-3 clearing-partner-name">
                        Advisor Representative Details
                      </div>
                      <AddToolTip
                        name={e.representativeName}
                        className="ft-14 font-weight-500 pb-3 clearing-partner-name"
                      />
                      <div className="clearing-partner-associated-plans">
                        {e.number}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </SliderPanel>
      {/* <div> */}
      {/* <Field
          isRequired
          name={fields.custodianId}
          label={"Clearing Partner"}
          value={values[fields.custodianId]}
          options={
            custodianData &&
            custodianData.map((item, index) => ({
              label: item.custodianCompanyName,
              value: item.custodianPlanMapId,
            }))
          }
          popupContent={
            <SearchableList
              isRadio
              isNotTypeAhead
              label="Clearing Partner"
              name={fields.custodianId}
              onSelect={(value) => {
                setTabGrey(2);
                setFieldValue(fields.custodianId, value);
              }}
              value={values[fields.custodianId]}
              options={
                custodianData &&
                custodianData.map((item, index) => ({
                  label: item.custodianCompanyName,
                  value: item.custodianPlanMapId,
                }))
              }
              disabled={isEdit && !isSave}
              isTypeAhead
            />
          }
          disabled={isEdit && !isSave}
          component={FieldDropSide}
        />

        {values[fields.custodianId] && (
          <>
            <Field
              name={fields.custodianAccountId}
              isRequired
              label="Clearing Partner Account ID"
              value={values[fields.custodianAccountId]}
              disabled={isEdit && !isSave}
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.CLEAING_PARTNER_ACCOUNT_ID
              )}
              popupContent={
                <SearchableList
                  label="Select an clearing partner account id"
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.CLEAING_PARTNER_ACCOUNT_ID
                  )}
                  isSelectedByDefault={true}
                  onSelect={(value) =>
                    setFieldValue(fields.custodianAccountId, value)
                  }
                  onChange={() => {
                    setTabGrey(2);
                  }}
                  disabled={isEdit && !isSave}
                  isNotTypeAhead
                />
              }
              component={FieldDropSide}
            />
            <Field
              label={"Clearance Time (EST)"}
              size="md"
              noLabelTransform={true}
              name={fields.clearanceTime}
              value={toMultiSelectValueById(
                values[fields.clearanceTime],
                toOptionValuesFromMapper(OPTIONS_DATA_MAPPER.CLEARANCE_TIME)
              )}
              isMultiSelect
              isRequired
              popupContent={
                <MultiSelectDropdown
                  label="Select"
                  name={fields.clearanceTime}
                  // isAllSelecetedByDefault={
                  //   toggle &&
                  //   values[fields.clearanceTime] !== undefined &&
                  //   isEmpty(values[fields.clearanceTime])
                  // }
                  setToggle={setToggle}
                  onSelect={(value) => {
                    setTabGrey(2);
                    setFieldValue(fields.clearanceTime, value);
                  }}
                  value={values[fields.clearanceTime]}
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.CLEARANCE_TIME
                  )}
                />
              }
              disabled={isEdit && !isSave}
              component={FieldDropSide}
            />
            {clearanceTime &&
              clearanceTime.length > 1 &&
              clearanceTime.length === 2 && (
                <div className="ft-12 grey-text mb-2">
                  All Clearance time values selected. If needed, please modify.
                </div>
              )}
          </>
        )}

        <Field
          size="smd"
          name={fields.excludeInvestmentFrom}
          label={"Exclude investment from"}
          isRequired
          options={toOptionValuesFromMapper(
            OPTIONS_DATA_MAPPER.EXCLUDE_INVESTMENT_FROM
          )}
          selectedValue={values[fields.excludeInvestmentFrom]}
          value={values[fields.excludeInvestmentFrom]}
          onChange={(value) => {
            setTabGrey(2);
            setFieldValue(fields.excludeInvestmentFrom, value);
          }}
          component={FieldMultiSelectButtonGroup}
          disabled={isEdit && !isSave}
        />
      </div> */}
    </LoaderWrapper>
  );
};

export default AdvisorRepresentativeDetails;
